module.exports = __webpack_public_path__ + "img/rating-park-30D0wq6.svg";